/**
 * F45 (Wave 2D) — sub-navigation across the analytics pages
 * (/analytics · /analytics/funnels · /analytics/retention · /analytics/geographic ·
 * /analytics/churn · /analytics/notifications · /analytics/alert-rules). Composed
 * of @bravemove/ui-web `Chip`s acting as a tab row. Scorecard pages are reached via
 * deep-links from the dashboard Top-N tables, so they are not in this nav.
 */
import { useI18n } from '@bravemove/i18n/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Chip } from '@bravemove/ui-web';

const TABS: ReadonlyArray<{ route: string; labelKey: string; testId: string }> = [
  {
    route: '/analytics',
    labelKey: 'admin:analytics.nav.dashboard',
    testId: 'analytics-nav-dashboard',
  },
  {
    route: '/analytics/funnels',
    labelKey: 'admin:analytics.nav.funnels',
    testId: 'analytics-nav-funnels',
  },
  {
    route: '/analytics/retention',
    labelKey: 'admin:analytics.nav.retention',
    testId: 'analytics-nav-retention',
  },
  {
    route: '/analytics/geographic',
    labelKey: 'admin:analytics.nav.geographic',
    testId: 'analytics-nav-geographic',
  },
  {
    route: '/analytics/churn',
    labelKey: 'admin:analytics.nav.churn',
    testId: 'analytics-nav-churn',
  },
  {
    route: '/analytics/notifications',
    labelKey: 'admin:analytics.nav.notifications',
    testId: 'analytics-nav-notifications',
  },
  {
    route: '/analytics/alert-rules',
    labelKey: 'admin:analytics.nav.alertRules',
    testId: 'analytics-nav-alert-rules',
  },
];

export function AnalyticsNav() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="flex flex-wrap items-center gap-2" aria-label={t('admin:analytics.title')}>
      {TABS.map((tab) => (
        <Chip
          key={tab.route}
          selected={pathname === tab.route}
          onClick={() => navigate(tab.route)}
          data-testid={tab.testId}
        >
          {t(tab.labelKey)}
        </Chip>
      ))}
    </nav>
  );
}
